import type { AdminHook } from './useAdmin';

type AdminFiltersProps = Pick<
	AdminHook,
	| 'entityFilter'
	| 'flowFilter'
	| 'flowOptions'
	| 'formatFlow'
	| 'formatStatus'
	| 'initiatorKennitala'
	| 'onEntityFilter'
	| 'onFlowFilter'
	| 'onInitiatorKennitala'
	| 'onSearch'
	| 'onStatusFilter'
	| 'search'
	| 'statusFilter'
	| 'statusOptions'
	| 't'
>;

export function AdminFilters({
	entityFilter,
	flowFilter,
	flowOptions,
	formatFlow,
	formatStatus,
	initiatorKennitala,
	onEntityFilter,
	onFlowFilter,
	onInitiatorKennitala,
	onSearch,
	onStatusFilter,
	search,
	statusFilter,
	statusOptions,
	t
}: Readonly<AdminFiltersProps>) {
	return (
		<div className="admin-dashboard__filters">
			<label className="admin-search" htmlFor="admin-search">
				<span className="admin-search__icon">⌕</span>
				<input
					id="admin-search"
					onChange={onSearch}
					placeholder={t('admin_search')}
					type="search"
					value={search}
				/>
			</label>

			<label className="admin-search" htmlFor="admin-search-initiator">
				<span className="admin-search__icon">⌕</span>
				<input
					id="admin-search-initiator"
					onChange={onInitiatorKennitala}
					placeholder={t('admin_search_initiator_kennitala') || 'Initiator kennitala'}
					type="search"
					value={initiatorKennitala}
				/>
			</label>

			<select className="admin-filter" onChange={onStatusFilter} value={statusFilter}>
				<option value="">{t('admin_all_statuses')}</option>
				{statusOptions.map(status => (
					<option key={status} value={status}>
						{formatStatus(Number(status))}
					</option>
				))}
			</select>

			<select className="admin-filter" onChange={onFlowFilter} value={flowFilter}>
				<option value="">{t('admin_all_flows')}</option>
				{flowOptions.map(flow => (
					<option key={flow} value={flow}>
						{formatFlow(flow)}
					</option>
				))}
			</select>

			<select className="admin-filter" onChange={onEntityFilter} value={entityFilter}>
				<option value="">{t('admin_all_types')}</option>
				<option value="person">{t('admin_individuals')}</option>
				<option value="company">{t('admin_legal_entities')}</option>
			</select>
		</div>
	);
}
